export default function MaintenancePage() {
    window.location.href = "https://invest.jra.tools";
    return (
        <div>
            <h1>Site en maintenance</h1>
            <br />
            <p>
                Nous effectuons actuellement une mise à jour de notre plateforme.
                <br />Le site sera de retour très bientôt.
            </p>
            <br />
            <div className="mt-6">
                <a
                    href="mailto:dev+invest@jeanrouyerautomobiles.fr"
                >
                    Contacter le support
                </a>
            </div>
        </div>
    );
}
